'use strict';

module.exports = {
    ACTIONS: {
        TYPE: {
            CATEGORY: 'CATEGORY',
            ATTRIBUTE: 'ATTRIBUTE'
        },
        FIELDS: {
            IMAGES: 'IMAGES'
        }
    },
    STORE: {
        FETCH_SUCCESS: 'trending:fetch:success',
        FETCH_ERROR: 'trending:fetch:error'
    }
};



// WEBPACK FOOTER //
// ./assets/js/global/constants/trendingConstants.es.js